
import { Component, Vue, Prop, computed } from 'vue-property-decorator'

@Component({
  components: {
  }
})
export default class TaskCard extends Vue {
  @Prop({ required: true })readonly id: number
  @Prop({ required: true })readonly title: string
  @Prop({ required: true })readonly due: Date
  @Prop({ required: true })readonly type: string
  @Prop({ required: true })readonly data: any
  @Prop({ required: false, default: false })readonly completed: boolean
  data () {
    return {
    }
  }

  get remainTime () {
    // (due.valueOf() - (new Date()).valueOf())
    var now = new Date()
    var days = (this.due.valueOf() - now.valueOf()) / (1000 * 3600 * 24)
    if (days <= 0) {
      return 'Expired'
    } else {
      var hours = (days - Math.floor(days)) * 24
      var mins = 0
      if ((hours - Math.floor(hours)) > 0) {
        mins = (hours - Math.floor(hours)) * 60
      }
      var daysString = days < 10 ? days < 1 ? '' : `0${Math.floor(days)} Days and ` : `${Math.floor(days)} Days and `
      var hoursString = hours < 10 ? `0${Math.floor(hours)}` : Math.floor(hours)
      var minsString = mins < 10 ? `0${Math.floor(mins)}` : Math.floor(mins)

      return `${daysString}${hoursString}:${minsString} h `
    }
  }

  get isLoggedIn () {
    return this.$store.state.loggedIn
  }

  goToTask () {
    if (this.type === 'REVIEW_EXPRESSIONS') {
      window.location.href = `/home/rankExpressions?id=${this.id}`
    } else if (this.type === 'FREE_WRITING') {
      window.location.href = `/home/freeWriting/${this.id}`
    } else if (this.type === 'FREE_SPEAKING') {
      window.location.href = `/home/freeSpeaking/${this.id}`
    } else if (this.type === 'REVIEW_TRANSCRIPT') {
      window.location.href = `/home/reviewTranscript/${this.id}`
    } else if (this.type === 'CALL') {
      window.location.href = `/home/call/${this.data.callId}`
    } else if (this.type === 'ANSWER_QUESTION') {
      window.location.href = `/home/task/${this.id}`
    } else if (this.type === 'SELECT_CHOICE') {
      window.location.href = `/home/task/${this.id}`
    } else if (this.type === 'FILL_IN_THE_BLANK') {
      window.location.href = `/home/task/${this.id}`
    } else if (this.type === 'HIGHLIGHT_PART_OF_SENTENCE') {
      window.location.href = `/home/task/${this.id}`
    } else if (this.type === 'PERFORM_ACTION_ON_PART_OF_SENTENCE') {
      window.location.href = `/home/task/${this.id}`
    } else if (this.type === 'REORDER_WORDS') {
      window.location.href = `/home/task/${this.id}`
    } else if (this.type === 'MATCH_EXPRESSIONS') {
      window.location.href = `/home/task/${this.id}`
    }
  }
}
